import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import PhotoSlotIcon from '../../../../../../icons/PhotoSlotIcon';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerPhotoControlsButton = ({ className, onClick, active }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<PhotoSlotIcon />}
      title="Photo Slots"
      onClick={onClick}
    />
  );
};

CardDesignerPhotoControlsButton.propTypes = propTypes;

export default CardDesignerPhotoControlsButton;
